export const columns = function() {
  return [
    {
      prop: 'name',
      label: '参数名称',
      minWidth: 50
    },
    {
      prop: 'value',
      label: '参数值',
      minWidth: 100
    },
    {
      prop: 'describe',
      label: '描述',
	  minWidth: 100
    },
	{
	  prop: "handle",
	  label: "操作",
	  minWidth: 50,
	},
  ]
} 

// 表单相关
export const formOption = function() {
  return [
	   {
		 prop: "name",
		 label: "参数名称",
		 type: "input",
		 width: "20%",
		 disabled: true
	   },
	   {
		 prop: "describe",
		 label: "描述",
		 type: "input",
		 width: "20%",
		 disabled: true
	   },
	   {
		 prop: "value",
		 label: "参数值",
		 type: "input",
		 placeholder: '请输入参数值',
		 width: "20%",
	   }
  ]
}

export default {}